module.exports = __webpack_public_path__ + "img/Abstract-platform.a979e04a.svg";